export const FUNNEL_STAGE = 'FUNNEL_STAGE';
export const PRODUCT_INTEREST = 'PRODUCT_INTEREST';
export const TIER_FIT = 'TIER_FIT';
export const FUNNEL_STAGE_OVERRIDE_VALUES = ['ACADEMY', 'DEVELOPER', 'CUSTOMER_SEEKING_SUPPORT', 'FREE_USER_WITH_SUPPORT_QUESTIONS'];